import React from 'react'

import { DateTime } from 'luxon'
import { TextField } from '@mui/material'

interface DateTimePickerUTCProps {
  handleUTCSelectedDateTimeChange: (
    e: React.ChangeEvent<HTMLInputElement>
  ) => void
  initialUTCSelectedDateTime: DateTime | null
  showLocal?: boolean
  label: string
  name: string
  error: boolean
  variant?: 'outlined' | 'filled' | 'standard'
}

export const DateTimePickerUTC: React.FC<DateTimePickerUTCProps> = ({
  initialUTCSelectedDateTime,
  handleUTCSelectedDateTimeChange,
  showLocal = false,
  label = 'Date',
  name,
  error,
  variant = 'standard'
}) => {
  let initialDateTime

  if (initialUTCSelectedDateTime != null) {
    initialDateTime = showLocal
      ? initialUTCSelectedDateTime.toLocal().toFormat("yyyy-MM-dd'T'HH:mm:ss")
      : initialUTCSelectedDateTime.toFormat("yyyy-MM-dd'T'HH:mm:ss")
  }

  return (
    <TextField
      variant={variant}
      error={error}
      helperText={error ? 'Rango de fechas no válido' : ''}
      id='datetime-local'
      label={label}
      type='datetime-local'
      onChange={handleUTCSelectedDateTimeChange}
      defaultValue={initialDateTime}
      InputLabelProps={{
        shrink: true
      }}
      name={name}
    />
  )
}
